import { Action, Mutation } from "../types";

export default {
  [Action.setGroupProfile]({ commit }: any, groupProfile: any) {
    commit(Mutation.SET_GROUP_PROFILE, groupProfile);
  },
  [Action.clearGroupProfile]({ commit }: any) {
    commit(Mutation.SET_GROUP_PROFILE, {});
  },
  [Action.setGroupProfiles]({ commit }: any, groupProfiles: any) {
    commit(Mutation.SET_GROUP_PROFILES, groupProfiles);
  },
  [Action.clearGroupProfiles]({ commit }: any) {
    commit(Mutation.SET_GROUP_PROFILES, {});
  },
  [Action.setInvitedGroup]({ commit }: any, invitedGroup: string) {
    commit(Mutation.SET_INVITED_GROUP, invitedGroup);
  },
  [Action.clearInvitedGroup]({ commit }: any) {
    commit(Mutation.SET_INVITED_GROUP, "");
  },
};
